import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';
import { ActionEnum, ApplyBoundEnum } from '@Policy/utils/types';
import { PolicyModeEnum } from '@Policy/utils/constants';

const cfg = {
  policySubType: 1,
  policyType: 22,

  tmFileblockings: {
    fbApplyBound: 2,
  },
  tmVirusscans: {
    vsApplyBound: 2,
    vsTextTagSubjectContent: 'Suspicious File:',
    vsWormsTrojansActionType: 109,
  },
  tmWebthreatprotections: {
    wtpApprovedHeaderList: '',
    wtpUrlcvEnabled: 1,
    wtpExtractAttachmentUrl: 1,
    wtpApplyBound: ApplyBoundEnum.all,
  },
  tmAntispamfilters: {
    asActionOthers: 6,
    asActionBec: 6,
    asApplyBound: 2,
    asApprovedHeaderList: '',
    asGreyMailEnabled: 0,
    asGrayEmailMmlEnabled: 0,
    asGrayEmailSocialNetworkEnabled: 0,
    asGrayEmailForumEnabled: 0,
    asGrayEmailBulkEnabled: 0,
  },
  tmDdafilters: {
    ddaApplyBound: 2,
  },
};

export function getGmailOutboundTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.tfWritingStyleToExpectedSenderFeedbackMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.ntfWritingStyleAdministratorMessage',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleExpectedSenderMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleAdministratorSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfWritingStyleAdministratorMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.GMAIL.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  const { policyMode } = tempConfig;
  if (policyMode === PolicyModeEnum.DefaultMonitorPolicy) {
    tempConfig.tmAntispamfilters.asActionBlockedSender = ActionEnum.quarantine;
  }
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
